var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Alert',{attrs:{"type":"error"}},[(_vm.errors.length > 1)?_c('ul',{staticClass:"md-margin-left"},[_c('li',[_vm._v("test")]),_c('li',[_vm._v("test")])]):_c('p',[_vm._v(" "+_vm._s(_vm.errors[0])+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }